import "./index.css";

import { AboutSection } from "./sections/AboutSection";
import { ContactSection } from "./sections/ContactSection";
import { Header } from "./sections/Header";
import { HeroSection } from "./sections/HeroSection";
import { PosterSection } from "./sections/PosterSection";
import { PressSection } from "./sections/PressSection";
import { RemerciementsSection } from "./sections/RemerciementsSection";
import { TourSection } from "./sections/TourSection";
import { PropagandeSection } from "./sections/PropagandeSection";


export function App() {
  return (
    <main className="site-shell">
      <Header />
      <HeroSection />
      <TourSection />
      <PressSection />
      <PosterSection />
      <AboutSection />
      <PropagandeSection />
      <ContactSection />
      <RemerciementsSection />
    </main>
  );
}

export default App;
  